"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Cloner {
  clone(object) {
    return JSON.parse(JSON.stringify(object));
  }
}
const cloner = new Cloner();
var _default = exports.default = cloner;